<div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100">
        <af-full-table class="w-100 h-100"
            [showImport]="false"
            [showExport]="false"
            [dataSource]="dataSource"
            (tableUpdateListener)="loadFiles($event)"
            additionalSpinnerIds="fraudReportFiles"
            placeholderContext="fraudReportFiles"
            emptyStateIconName="ic_empty_state_no_data"
            emptyStateTitleTranslationKey="i18n_af_emptyStateSubtitleNoData"
        />
</div>


